import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-overview-contract-summary',
  templateUrl: './overview-contract-summary.component.html',
  styleUrls: ['./overview-contract-summary.component.scss'],
})
export class OverviewContractSummaryComponent implements OnInit {

  @Input() contractSummary: any;
  @Input() showGeneralFaqs = false;

  generalFaqsDocs: any[] = [];
  specificFaqsDocs: any[] = [];
  contractDocs: any[] = [];

  hasSection = false;
  sectionInfo: any;
  viewMore = false;
  viewMoreBlur = false;

  constructor(private translate: TranslateService, private chdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.buildDocuments(this.translate.currentLang);
    this.translate.onLangChange.subscribe(event => {
      this.buildDocuments(event.lang);
      this.chdRef.detectChanges();
    });
  }

  private buildDocuments(currentLang: string) {
    this.generalFaqsDocs = [];
    this.specificFaqsDocs = [];
    this.contractDocs = [];
    this.hasSection = false;
    this.sectionInfo = null;

    this.buildGeneralFaqs();
    this.buildFromNewFormat(currentLang);
  }

  private buildGeneralFaqs() {
    if (!this.showGeneralFaqs) return;
    const htmlString = this.translate.instant('OVERVIEW.GENERIC_RESERVATION_FAQS');
    if (!htmlString || htmlString === 'OVERVIEW.GENERIC_RESERVATION_FAQS') return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const h1List = doc.getElementsByTagName('h1');
    const divList = doc.getElementsByTagName('div');

    for (let i = 0; i < h1List.length; i++) {
      this.generalFaqsDocs.push({
        index: i,
        opened: false,
        title: h1List[i].innerHTML,
        content: divList[i]?.innerHTML || '',
        idContent: `gen_content${i}`
      });
    }
  }

  private buildFromNewFormat(currentLang: string) {
    const langData = this.contractSummary[currentLang] || this.contractSummary['es'];
    if (!langData) return;

    if (langData?.contract_summary?.length) {
      const items = [...langData.contract_summary].sort((a, b) => a.sortOrder - b.sortOrder);
      let index = 0;
      for (const item of items) {
        const parsed = this.splitContractByH1(item, index);
        this.contractDocs.push(...parsed);
        index += parsed.length;
      }
    }

    if (langData?.faq?.length) {
      const items = [...langData.faq].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
      this.specificFaqsDocs = items.map((item, i) => ({
        index: i,
        opened: false,
        title: item.title,
        content: item.content,
        idContent: `spec_content${i}`
      }));
    }
  }

  private splitContractByH1(item: any, startIndex: number): any[] {
    const content = item.content;
    if (!content) {
      return [{ index: startIndex, opened: false, title: item.title, content: '', idContent: `cont_content${startIndex}` }];
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const h1List = doc.getElementsByTagName('h1');

    if (h1List.length === 0) {
      return [{ index: startIndex, opened: false, title: item.title, content, idContent: `cont_content${startIndex}` }];
    }

    const results = [];
    const bodyChildren = Array.from(doc.body.childNodes);
    let index = startIndex;

    for (let i = 0; i < bodyChildren.length; i++) {
      const node = bodyChildren[i] as Element;
      if (node.tagName !== 'H1') continue;
      let itemContent = '';
      for (let j = i + 1; j < bodyChildren.length; j++) {
        const next = bodyChildren[j] as Element;
        if (next.tagName === 'H1') break;
        if (next.tagName === 'DIV') { itemContent = next.innerHTML; break; }
      }
      results.push({ index, opened: false, title: node.innerHTML, content: itemContent, idContent: `cont_content${index}` });
      index++;
    }

    return results;
  }

  openItem(element: any) {
    element.opened = !element.opened;
    const el = document.getElementById(element.idContent);
    if (!el) return;
    if (element.opened) {
      el.style.height = `${el.scrollHeight}px`;
      el.style.transition = 'height 0.5s';
    } else {
      el.style.height = '0px';
      el.style.transition = 'height 0.5s';
    }
  }

  toggleSection() {
    this.viewMore = !this.viewMore;
    const el = document.getElementById('sectionInfo');
    if (!el) return;
    if (this.viewMore) {
      el.style.height = `${el.scrollHeight}px`;
      el.style.transition = 'height 0.5s';
      this.viewMoreBlur = true;
    } else {
      el.style.height = '68px';
      el.style.transition = 'height 0.5s';
      setTimeout(() => {
        this.viewMoreBlur = false;
      }, 500);
    }
  }

}